import { render, staticRenderFns } from "./zi_list.vue?vue&type=template&id=608b8cf8&scoped=true&"
import script from "./zi_list.vue?vue&type=script&lang=js&"
export * from "./zi_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608b8cf8",
  null
  
)

export default component.exports